<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M10.4337 0.617144C10.6213 0.0815424 11.3787 0.0815423 11.5663 0.617144L13.6982 6.70517C13.7808 6.94107 14.001 7.10105 14.2508 7.10672L20.6997 7.25295C21.267 7.26582 21.5011 7.9862 21.0497 8.33009L15.9184 12.2389C15.7196 12.3904 15.6355 12.6492 15.7073 12.8886L17.561 19.0671C17.7241 19.6106 17.1113 20.0558 16.6448 19.7328L11.3416 16.0605C11.1361 15.9182 10.8639 15.9182 10.6584 16.0605L5.35524 19.7328C4.88869 20.0558 4.27589 19.6106 4.43898 19.0671L6.29271 12.8886C6.36453 12.6492 6.28043 12.3904 6.0816 12.2389L0.950326 8.33009C0.498896 7.9862 0.732964 7.26582 1.30031 7.25295L7.74916 7.10672C7.99904 7.10105 8.21923 6.94107 8.30184 6.70517L10.4337 0.617144Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 22,
		height: 20,
		iconColor: '#D9D9D9',
	}
);
</script>

<style lang="scss" scoped></style>
